import { useState } from "react";
import { useApi, usePagedList } from "@/lib/api";
import { ArticleCard } from "@/components/site/ArticleCard";
import { Container, LoadingGrid, PageHeader } from "@/components/site/PageHeader";
import { LoadMore, SearchBox } from "@/components/site/ListControls";

const CAT_LABEL = { Video: "Vidéo" };
const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export const NEWS_FILTER = { source: "/news-categories", param: "category", testId: "news-categories", itemTestId: "news-category" };
export const PODCAST_FILTER = { source: "/podcast-types", param: "type", testId: "podcast-types", itemTestId: "podcast-type" };

const FilterChips = ({ filter, value, onChange }) => {
  const { data } = useApi(filter.source);
  const items = Array.isArray(data) ? data : [];
  if (!items.length) return null;
  const chip = (active) =>
    `px-4 py-2 border text-xs uppercase tracking-[0.2em] font-bold transition-colors duration-200 ${
      active ? "bg-primary border-primary text-white" : "border-white/20 text-zinc-300 hover:border-white hover:text-white"}`;
  return (
    <div className="flex flex-wrap gap-2" data-testid={filter.testId}>
      <button onClick={() => onChange(null)} className={chip(!value)} data-testid={`${filter.itemTestId}-all`}>Tout</button>
      {items.map((c) => (
        <button key={c.name} onClick={() => onChange(c.name)} className={chip(value === c.name)} data-testid={`${filter.itemTestId}-${slug(c.name)}`}>
          {CAT_LABEL[c.name] || c.name} <span className="opacity-60 ml-1">{c.count}</span>
        </button>
      ))}
    </div>
  );
};

export const ArticleList = ({ path, prefix, filter }) => {
  const [value, setValue] = useState(null);
  const list = usePagedList(path, filter && value ? { [filter.param]: value } : {});
  return (
    <>
      <Container className="pt-12 space-y-8">
        <SearchBox value={list.q} onChange={list.setQ} placeholder="Rechercher un artiste, un titre…" testId={`${prefix}-search`} />
        {filter && <FilterChips filter={filter} value={value} onChange={setValue} />}
      </Container>
      <Container className="py-16">
        {list.isLoading ? (
          <LoadingGrid />
        ) : list.items.length === 0 ? (
          <p className="text-zinc-400" data-testid={`${prefix}-empty`}>Aucun résultat.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16" data-testid={`${prefix}-grid`}>
            {list.items.map((n, i) => <ArticleCard key={n.id} item={n} index={i % 24} prefix={prefix} />)}
          </div>
        )}
        <LoadMore list={list} testId={`${prefix}-load-more`} />
      </Container>
    </>
  );
};

export function News() {
  return (
    <>
      <PageHeader top="Magazine" bottom="& chroniques" testId="news-header"
        intro="Sorties, chroniques et coups de cœur de la rédaction : tout ce qui groove." />
      <ArticleList path="/news" prefix="news" filter={NEWS_FILTER} />
    </>
  );
}
